import { useAccountActivityQuery } from '@syf-api-library/account-activity';
import { useMemo } from 'react';
import useConfig from '../../context/config.context';
import useSteps from '../../context/steps.context';
const activityTransform = (currentLang) => (activity) => {
    const { description = '', postedDate = '', amount: transactionAmount = '', transactionInfo = {} } = activity;
    const { merchant = {}, transactionId = '', skuReferenceNumber: referenceNumber = '' } = transactionInfo;
    const { addressLine1, addressLine2, city, state, zip, name: purchaseLocation = '' } = merchant;
    const date = new Date(postedDate);
    const formattedDate = date.toLocaleString(currentLang, {
        month: 'short',
        day: 'numeric'
    });
    const transaction = {
        description,
        transactionId,
        transactionAmount,
        referenceNumber,
        purchaseLocation,
        formattedDate
    };
    if (addressLine1 && city && state && zip) {
        const cleanedAddress2 = addressLine2 ? ` ${addressLine2}` : '';
        transaction.address = `${addressLine1}${cleanedAddress2}, ${city}, ${state} ${zip}`;
    }
    return transaction;
};
const useAccountActivity = (currentLang) => {
    const { stepsState: { activeStep } } = useSteps();
    const { config, accountId } = useConfig();
    const { data, isSuccess } = useAccountActivityQuery({
        config,
        queryOptions: {
            enabled: activeStep === 'RecognizeTransactions'
        },
        keyProps: { accountId, accountIdType: 'guid' }
    });
    const transactions = useMemo(() => {
        if (!(data === null || data === void 0 ? void 0 : data.activity.length))
            return [];
        data.activity.sort((transactionA, transactionB) => {
            const dateA = new Date(transactionA.postedDate || '');
            const dateB = new Date(transactionB.postedDate || '');
            return dateB.getTime() - dateA.getTime();
        });
        return data.activity.slice(0, 5).map(activityTransform(currentLang));
    }, [data, currentLang]);
    return { transactions, isSuccess };
};
export default useAccountActivity;
//# sourceMappingURL=index.js.map